// src/blocks/icon/SVGs/play.tsx
import * as React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var PlaySVG = ({
  title = "Play Icon",
  width = 16,
  height = 16,
  ...props
}) => {
  const titleId = React.useId();
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width,
      height,
      "aria-labelledby": titleId,
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        /* @__PURE__ */ jsx("title", { id: titleId, children: title }),
        /* @__PURE__ */ jsx("path", { d: "M14 8L5 2L5 14L14 8Z", fill: "currentColor" })
      ]
    }
  );
};
var play_default = PlaySVG;

export {
  play_default
};
